import React, { useEffect, useRef } from 'react';
import videoFile1 from '../../../assets/video1contact.mp4';

const VideoPlayerOfContact1 = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (videoRef.current) {
        const scrollY = window.scrollY;
        videoRef.current.style.transform = `translateY(-${scrollY * 0.7}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div style={{ position: 'relative', overflow: 'hidden', height: '40vh' }}>
      <video
        ref={videoRef} 
        src={videoFile1}
        alt="Eye Video"
        autoPlay
        loop
        muted
        style={{ width: '100%', height: 'auto', position: 'absolute', top: '1300px', left: 0 }}
      />
    </div>
  );
};

export default VideoPlayerOfContact1;
